import { http, HttpResponse } from 'msw';
import { DEMO_USER, createDemoJwt } from '../demo-fixtures';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demAuthHandlers = [
  http.get(`${BASE}/api/v1/auth/me`, () => {
    return HttpResponse.json(DEMO_USER);
  }),

  // Block real login in demo mode — should not be called, but just in case
  http.post(`${BASE}/api/v1/auth/login`, () => {
    return HttpResponse.json({
      access_token: createDemoJwt(),
      refresh_token: 'demo-no-refresh',
      token_type: 'bearer',
    });
  }),

  // Intercept refresh attempts — demo has no real refresh token
  http.post(`${BASE}/api/v1/auth/refresh`, () => {
    return HttpResponse.json(
      { detail: 'Demo mode: session refresh not supported' },
      { status: 401 },
    );
  }),

  // Change password — show success in demo
  http.post(`${BASE}/api/v1/auth/change-password`, () => {
    return HttpResponse.json({ message: 'Password updated (DEMO — no real change)' });
  }),
];
